export default __webpack_public_path__ + "static/media/pbx-user-brand-logo.e9464b77.svg";